import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
};

const [useDeleteSpace, deleteSpace] = createAsyncAction(
  "spaces/delete",
  async ({ spaceId }: Args) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.space };
  }
);

export default useDeleteSpace;
export { deleteSpace };
